export function createCorporateAccountsClient(transport) {
    return {
        /**
         * The corporate accounts the signed-in person manages
         *
         * Requires scope: corporate:read
         */
        listMyCorporateAccounts(options) {
            return transport.request({
                method: "GET",
                path: "/v1/corporate-accounts",
                options,
            });
        },
        /**
         * Every corporate account in the tenant, for an operator rather than a manager
         *
         * Requires scope: corporate:any
         */
        listPlatformCorporateAccounts(options) {
            return transport.request({
                method: "GET",
                path: "/v1/platform/corporate-accounts",
                options,
            });
        },
        /**
         * Cost centres with what each has spent in the period
         *
         * Requires scope: corporate:read
         */
        listCostCentres(accountId, from, to, options) {
            return transport.request({
                method: "GET",
                path: `/v1/corporate-accounts/${encodeURIComponent(accountId)}/cost-centres`,
                query: { from: from, to: to },
                options,
            });
        },
        /**
         * Add a cost centre
         *
         * Requires scope: corporate:write
         */
        addCostCentre(accountId, body, options) {
            return transport.request({
                method: "POST",
                path: `/v1/corporate-accounts/${encodeURIComponent(accountId)}/cost-centres`,
                body,
                options,
            });
        },
        /**
         * Who can ride on the company account, and under which cost centre
         *
         * Requires scope: corporate:read
         */
        listCorporateEmployees(accountId, from, to, options) {
            return transport.request({
                method: "GET",
                path: `/v1/corporate-accounts/${encodeURIComponent(accountId)}/employees`,
                query: { from: from, to: to },
                options,
            });
        },
        /**
         * Invite employees by work email
         *
         * Requires scope: corporate:write
         */
        inviteCorporateEmployees(accountId, body, options) {
            return transport.request({
                method: "POST",
                path: `/v1/corporate-accounts/${encodeURIComponent(accountId)}/employees`,
                body,
                options,
            });
        },
        /**
         * Rules each ride is checked against before it is booked
         *
         * Requires scope: corporate:read
         */
        listTravelPolicies(accountId, options) {
            return transport.request({
                method: "GET",
                path: `/v1/corporate-accounts/${encodeURIComponent(accountId)}/travel-policies`,
                options,
            });
        },
        /**
         * Add a travel policy
         *
         * Requires scope: corporate:write
         */
        addTravelPolicy(accountId, body, options) {
            return transport.request({
                method: "POST",
                path: `/v1/corporate-accounts/${encodeURIComponent(accountId)}/travel-policies`,
                body,
                options,
            });
        },
        /**
         * Every business ride in the period, with its cost centre and policy check
         *
         * Requires scope: corporate:read
         */
        listCorporateRides(accountId, from, to, options) {
            return transport.request({
                method: "GET",
                path: `/v1/corporate-accounts/${encodeURIComponent(accountId)}/rides`,
                query: { from: from, to: to },
                options,
            });
        },
        /**
         * Every corporate invoice in the tenant, for a finance operator
         *
         * Requires scope: corporate:invoices:read
         */
        listTenantCorporateInvoices(options) {
            return transport.request({
                method: "GET",
                path: "/v1/corporate-invoices",
                options,
            });
        },
        /**
         * Monthly invoices for the company, generated from posted rides
         *
         * Requires scope: corporate:read
         */
        listCorporateInvoices(accountId, options) {
            return transport.request({
                method: "GET",
                path: `/v1/corporate-accounts/${encodeURIComponent(accountId)}/invoices`,
                options,
            });
        },
        /**
         * The legal entity an invoice is addressed to
         *
         * Requires scope: corporate:write
         */
        updateCorporateBillingDetails(accountId, body, options) {
            return transport.request({
                method: "PATCH",
                path: `/v1/corporate-accounts/${encodeURIComponent(accountId)}/billing-details`,
                body,
                options,
            });
        },
        /**
         * Record that a business ride happened, idempotently
         *
         * Requires scope: corporate:posting:write
         */
        postCorporateRide(accountId, body, options) {
            return transport.request({
                method: "POST",
                path: `/internal/v1/corporate-accounts/${encodeURIComponent(accountId)}/ride-postings`,
                body,
                options,
            });
        },
        /**
         * Issue an invoice or a credit note
         *
         * Requires scope: corporate:invoice:issue
         */
        issueCorporateInvoice(accountId, body, options) {
            return transport.request({
                method: "POST",
                path: `/internal/v1/corporate-accounts/${encodeURIComponent(accountId)}/invoices`,
                body,
                options,
            });
        },
        /**
         * Report this service's identity and declared implementation status
         */
        getServiceInfo(options) {
            return transport.request({
                method: "GET",
                path: "/v1/service-info",
                options,
            });
        },
    };
}
//# sourceMappingURL=corporate-accounts.js.map